import React, { useCallback, useMemo } from 'react';

import { Input } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';

import { schemaUtils } from '../../../integration-test-modal.utils';
import { INumberFieldProps } from '../schema-form-field.types';

export const NumberField: React.FC<INumberFieldProps> = ({
  name,
  path,
  property,
  value,
  onChange,
  required
}) => {
  const fieldLabel = useMemo(
    () => schemaUtils.formatFieldLabel(name, property.title),
    [property.title, name]
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(path, Number(e.target.value));
    },
    [path, onChange]
  );

  const placeholderValue = useMemo(() => {
    if (property.default === undefined) {
      return undefined;
    }
    return String(property.default);
  }, [property.default]);

  return (
    <Input
      type="number"
      label={fieldLabel}
      isRequired={required}
      description={property.description}
      value={String(value ?? '')}
      onChange={handleInputChange}
      placeholder={placeholderValue}
      min={property.minimum}
      max={property.maximum}
      required={required}
      readOnly={property.readOnly}
      disabled={property.readOnly}
    />
  );
};
